// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"10d07c50","462":"ef9b6cfe"}[chunkId] + ".chunk.css";
};